/* istanbul ignore file */
import type { ComponentProps } from 'react';

import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { CalloutBody as CalloutBodySunrise } from './CalloutBody';
import { CalloutBody as CalloutBodyLegacy } from './CalloutBodyLegacy';

export const CalloutBody = (props: ComponentProps<typeof CalloutBodyLegacy>) => {
	const isSunriseThemeEnabled = useIsSunriseTheme();

	if (isSunriseThemeEnabled) return <CalloutBodySunrise {...props} />;

	return <CalloutBodyLegacy {...props} />;
};
